import { render, staticRenderFns } from "./InputComp.vue?vue&type=template&id=2c060d86&"
import script from "./InputComp.vue?vue&type=script&lang=ts&"
export * from "./InputComp.vue?vue&type=script&lang=ts&"
import style0 from "./InputComp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports